













import Vue from 'vue'
import Component from 'vue-class-component'

@Component<MinimalisticDropdown>({
  props: {
    array: Array,
    selectedItem: String
  }
})

export default class MinimalisticDropdown extends Vue {
  /**
   * Props variables
   */
  array: any[] = []
  selectedItem: string | undefined

  /**
   * Component state variables
   */
  showBox: boolean = false

  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */
  changeShowBox() {
    this.showBox = !this.showBox

    if (this.showBox) {
      // Add event listener to close the dropdown when the user clicks outside of the component
      document.addEventListener('click', this.closeDropdownOnClickOutside)
    } else {
      // Remove event listener when the dropdown is closed
      document.removeEventListener('click', this.closeDropdownOnClickOutside)
    }
  }

  itemClicked(item: any) {
    this.$emit('itemClicked', item)
    this.changeShowBox()
  }

  closeDropdownOnClickOutside(event: MouseEvent) {
    const dropdownElement = this.$refs.dropdown as HTMLElement

    if (dropdownElement !== undefined && !dropdownElement.contains(event.target as Node))
      this.showBox = false;
  }
}
